import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextFontSizes, TextFontWeights, TextLineHeights, Youtube } from "@cinch-labs/design-system";
import styles from "./finance-explained.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
import youtubeCoverImage from "./assets/ways-to-buy.jpeg";
function FinanceExplained({ i18n  }) {
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsxs("article", {
            className: styles.youtubeWrapper,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    className: styles.youtubeWrapperTitle,
                    fontSize: TextFontSizes["3xl"],
                    fontWeight: TextFontWeights.bold,
                    lineHeight: TextLineHeights.display,
                    children: i18n.sectionTitle
                }),
                /*#__PURE__*/ _jsx(Youtube, {
                    videoId: "rHYjjHiJcro",
                    title: i18n.videoTitle,
                    customThumbnail: youtubeCoverImage.src,
                    buttonLabel: `${i18n.cta.start} ${i18n.videoTitle} ${i18n.cta.end}`,
                    showNewPlayIcon: true
                })
            ]
        })
    });
}
export default FinanceExplained;
